<div *ngIf="organisation">
    <div [ngSwitch]="organisation.organisationID">
      <app-sports-profile-page *ngSwitchCase="2" [organisation]="organisation" [isSuperAdmin] = "isAdmin"></app-sports-profile-page>
      <app-firedepartment-page *ngSwitchCase="3" [organisation]="organisation" [isSuperAdmin] = "isAdmin"></app-firedepartment-page>
      <app-regional-authority *ngSwitchCase="4" [organisation]="organisation" [isSuperAdmin] = "isAdmin"></app-regional-authority>
      <app-church-page *ngSwitchCase="5" [organisation]="organisation" [isSuperAdmin] = "isAdmin"></app-church-page>
       <!--Add more organisation types as needed--> 
    </div>
  </div>
